import Header from "../components/Header";
import "./scss/resFinal.scss";
import { useDispatch, useSelector } from "react-redux";
import { useCommonUtil } from "../util/useCommonUtil";
import { rootReducer } from "../store/store";
import axiosInstance from "../api/axiosInstance";
import { useState, useEffect, useRef } from "react";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import { useHistory } from "react-router-dom";
import PayModal from "../components/PayModal";
import { AdditionChargeInfo } from "../types/AdditionChargeInfoTypes";
import { carInfo, driver } from "../actions/authActions";
import ProgressBar from "../components/ProgressBar";
import { ApprovalResult, errorMessages } from "../types/ApprovalResult";
import ConfirmModal from "../components/ConfirmModal";
import AlertModal from "../components/AlertModal";
import { AxiosError, AxiosResponse } from "axios";
import { CarInsuranceInfo } from "../types/CarInsuranceChargeTypes";
import { usePrintUtils } from "../util/usePrintUtils";
import ReceiptPrintService from "../api/ReceiptPrintService";
import ReservationService from "../api/ReservationService";
import { LicenseCheckType } from "../validators/driverValidators";
import {
  AlertType,
  alertType
} from "../types/CommonType";

type AuthState = ReturnType<typeof rootReducer>;
const months = Array.from({ length: 12 }, (_, index) => index + 1);
declare global {
  interface Window {
    printExchange: any;
    printExchangeCustomer: any;
    paySuccess: any;
    payFail: any;
    getCustomerKeepInfo: any;
    getEmployeeSubmissionInfo: any;
  }
}

const alertInfoType = {
  alertShow: false,
  title: "",
  content: ""
};

const ResFinal: React.FC = () => {
  window.printExchange = printExchange;
  window.printExchangeCustomer = printExchangeCustomer;
  window.paySuccess = paySuccess;
  window.payFail = payFail;
  window.getCustomerKeepInfo = getCustomerKeepInfo;
  window.getEmployeeSubmissionInfo = getEmployeeSubmissionInfo;

  const dispatch = useDispatch();
  const history = useHistory();
  const { formatNumber } = useCommonUtil();
  const [alertInfoFinal, setAlertInfoFinal] = useState(alertInfoType);
  const [installText, setInstallText] = useState<string>("일시불");
  const [companyCallInfo, setCompanyCallInfo] = useState<string>("");
  const [customerCaution, setCustomerCaution] = useState<string>("");
  const [returnAddrInfo, setReturnAddrInfo] = useState<string>("");
  const [parkingStr, setParkingStr] = useState<string>("");
  const [parkingDetail, setParkingDetail] = useState<string>("");
  const [installIdx, setInstallIdx] = useState<number>(0);
  const [installShow, setInstallShow] = useState<boolean>(false);
  const [customerAdress, setCustomerAdress] = useState<string>("");
  // const [payModalShow, setPayModalShow] = useState<boolean>(false);
  const [progressShow, setProgressShow] = useState<boolean>(false);
  const [confirmShow, setConfirmShow] = useState<boolean>(false);
  const [confirmTitle, setConfirmTitle] = useState<string>("");
  const [confirmMessge, setConfirmMessge] = useState<string>("");
  const [payCallDisabled, setPayCallDisabeld] = useState<boolean>(false);
  const [overlayDisabled, setOverlayDisabled] = useState<boolean>(false);
  const [companyInfo, setCompanyInfo] = useState<any>({});
  const resInfo = useSelector((state: AuthState) => state.store.resOneInfo);
  const driverPrev = useSelector((state: AuthState) => state.store.driver);
  const product = useSelector((state: AuthState) => state.store.product);
  const totalPrice = useSelector((state: AuthState) => state.store.totalPrice);
  const kioskInfo = useSelector((state: AuthState) => state.store.kioskInfo);
  const driverInfo = driverPrev && driverPrev.data;
  const divRef = useRef<HTMLDivElement>(null);
  const backButton = document.getElementById("backButton");

  // 고객 보관용 / 직원 제출용 인수증 출력 데이터
  const { convertReceiptListToObject } = usePrintUtils();
  const printInfo = useRef<any>({});

  const [alertInfo, setAlertInfo] = useState<AlertType>(alertType);

  console.log("resInfo", resInfo);
  console.log("totalPrice", totalPrice);
  console.log("product", product);
  console.log("driverInfo", driverInfo);

  

  // 기본 보험(일반자차/고급자차 등등) 골라내기
  const carIns =
    resInfo?.data?.carInsuranceChargeInfo &&
    resInfo?.data?.carInsuranceChargeInfo.length > 0 &&
    resInfo?.data?.carInsuranceChargeInfo?.filter(
      (e) => e.carInsuranceInfo.insuranceType !== "4000"
    );

  // 자차미가입 시, 체크인 과정에서 자차를 가입하면 해당 변수로 처리
  const addedInsurance = 
    product?.data &&
      product?.data?.addInsuranceArr &&
      product?.data?.addInsuranceArr.length > 0 &&
      product?.data?.addInsuranceArr?.filter(
        (e : CarInsuranceInfo) => e.carInsuranceInfo.insuranceType !== "4000"
      );

  console.log("carIns", carIns);
  console.log("addedInsurance", addedInsurance);
  let addInsPrice: number = 0;

  // 보험 금액 합산
  if (
    product?.data &&
    product?.data.addInsuranceArr &&
    product?.data.addInsuranceArr.length > 0
  ) {
    addInsPrice = product?.data.addInsuranceArr.reduce(
      (total: any, item: any) => total + (item.chargeRequester || 0),
      0
    );
  }

  // 상품 금액 합산
  let addProdPrice: number = 0;
  if (
    product?.data &&
    product?.data.addProductArr &&
    product?.data.addProductArr.length > 0
  ) {
    addProdPrice = product?.data.addProductArr.reduce(
      (total: any, item: any) => total + (item.chargeRequester || 0),
      0
    );
  }

  // 결제 모듈 호출 (C# 통신)
  const payCall = async () => {
    console.log("!!");
    if (totalPrice + (addInsPrice + addProdPrice) === 0) {
      setProgressShow(true);
      setPayCallDisabeld(true);
      saveDataProcess();//예약내용저장
    } else {
      const ApprovalStatus: HTMLInputElement | null = document.getElementById(
        "ApprovalStatus"
      ) as HTMLInputElement | null;

      if (ApprovalStatus?.value === "") {

        if (divRef.current) {
          divRef.current.style.pointerEvents = "none";
        }

        if (backButton) {
          backButton.style.pointerEvents = "none";
        }

        const inputElement: HTMLInputElement | null = document.getElementById(
          "kioskOperation"
        ) as HTMLInputElement | null;

        if (inputElement) {
          inputElement.value = "ApprovalFee";
        }

        if (ApprovalStatus) {
          ApprovalStatus.value = "Process";
        }

        const inputElement2: HTMLInputElement | null = document.getElementById(
          "transactionNum"
        ) as HTMLInputElement | null;
        if (inputElement2) {
          if (process.env.REACT_APP_ENV === "prod") {
            inputElement2.value = String(resInfo?.data.reservationId);
          } else {
            inputElement2.value = String(
              Math.floor(Math.random() * 1000000)
            ).padStart(6, "0");
          }
        }

        const inputElement3: HTMLInputElement | null = document.getElementById(
          "approvalCharge"
        ) as HTMLInputElement | null;
        if (inputElement3) {
          inputElement3.value = String(
            totalPrice + (addInsPrice || 0) + addProdPrice
          );
        }

        const inputElement4: HTMLInputElement | null = document.getElementById(
          "approvalInstallMonth"
        ) as HTMLInputElement | null;
        if (inputElement4) {
          inputElement4.value = String(installIdx);
        }
      }
    }
    setTimeout(() => {
      window.dispatchEvent(new Event("customPropertyChange"));
    }, 6000);
  };

  // 결제 (일시불, 할부) 구분
  const installClick = (idx: number) => {
    if (idx === 0) setInstallText("일시불");
    else setInstallText(idx + "개월");

    setInstallIdx(idx);
    setInstallShow(false);
  };

  const getBillInfo = async () => {
    try{
      await axiosInstance()
        .post(`/kiosk/GetBillInfo.do`, {
          companyId: resInfo?.data.companyId
        })
        .then((res) => {
          console.log("res", res.data);
          if (res.data.length > 0) {
            res.data.map((e: any) => {
              console.log(e);
              if (e.termsType === "COMPANY_CALL_INFO") {
                setCompanyCallInfo(e.contents);
                setCustomerAdress(e.address);
              }
              if (e.termsType === "CUSTOMER_CAUTION") {
                setCustomerCaution(e.contents);
              }
              if (e.termsType === "RETURN_ADDR_INFO") {
                setReturnAddrInfo(e.contents);
              }
            });
          }
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 에러",
          content: "에러가 발생했습니다.<br/>다시 시도해주세요.",
          callback: () => history.push("/addEtc")
      });
    }
  };

  // 영수증 출력 (C# 통신) => 영수증 출력하고 kioskOperation 값을 변경해서 교환증 출력 실행
  function printExchange(status: string) {
    console.log(status);

    if (divRef.current) {
      divRef.current.style.pointerEvents = "none";
    }

    if (backButton) {
      backButton.style.pointerEvents = "none";
    }

    if (String(status) === "receiptPrintComplete") {
      setTimeout(() => {
        setProgressShow(false);
        setPayCallDisabeld(false);
        history.push("/finish");
      }, 1000);
    } else {
      setConfirmShow(true);
      setConfirmTitle("결제 영수증 출력 실패");
      setConfirmMessge(
        "결제 영수증 출력 시 문제가 발생하였습니다.<br/> 다시 출력하시겠습니까?"
      );
      setProgressShow(false);
      setPayCallDisabeld(false);
    }

    // if (String(status) === "receiptPrintComplete") {
    //   const kioskOperation: HTMLInputElement | null = document.getElementById(
    //     "kioskOperation"
    //   ) as HTMLInputElement | null;
    //   if (kioskOperation) {
    //     kioskOperation.value = "printExchangeTicket"; 
    //   }
    // } else {
    //   setConfirmShow(true);
    //   setConfirmTitle("결제 영수증 출력 실패");
    //   setConfirmMessge(
    //     "결제 영수증 출력 시 문제가 발생하였습니다.<br/> 다시 출력하시겠습니까?"
    //   );
    //   setProgressShow(false);
    //   setPayCallDisabeld(false);
    // }
  }

  // 교환증 출력 (C# 통신)
  function printExchangeCustomer(status: string) {

    if (divRef.current) {
      divRef.current.style.pointerEvents = "none";
    }

    if (backButton) {
      backButton.style.pointerEvents = "none";
    }

    if (String(status) === "exchangeTicketPrintComplete") {
      if(totalPrice + (addInsPrice + addProdPrice) > 0) {
        const kioskOperation: HTMLInputElement | null = document.getElementById(
          "kioskOperation"
        ) as HTMLInputElement | null;
        if (kioskOperation) {
          kioskOperation.value = "printRentInfo"; 
        }
      } else {
        setTimeout(() => {
          setProgressShow(false);
          setPayCallDisabeld(false);
          history.push("/finish");
        }, 1000);
      }
    } else {
      setConfirmShow(true);
      setConfirmTitle("예약정보 영수증 출력 실패");
      setConfirmMessge(
        "예약 정보 및 교환증 출력 시 문제가 발생하였습니다.<br/> 다시 출력 하시겠습니까?"
      );
    }

    // if (String(status) === "exchangeTicketPrintComplete") {
    //   setTimeout(() => {
    //     setProgressShow(false);
    //     setPayCallDisabeld(false);
    //     history.push("/finish");
    //   }, 1000);
    // } else {
    //   setConfirmShow(true);
    //   setConfirmTitle("예약정보 영수증 출력 실패");
    //   setConfirmMessge(
    //     "예약 정보 및 교환증 출력 시 문제가 발생하였습니다.<br/> 다시 출력 하시겠습니까?"
    //   );
    // }
  }

  // 고객 보관용 인수증 데이터 (C# 에서 호출)
  function getCustomerKeepInfo() {
    const currentInfo = printInfo.current;

    if (divRef.current) {
      divRef.current.style.pointerEvents = "none";
    }

    if (backButton) {
      backButton.style.pointerEvents = "none";
    }

    console.log("getCustomerKeepInfo", currentInfo.customerKeepInfo);
    return currentInfo.customerKeepInfo;
  }

  // 직원 제출용 인수증 데이터 (C# 에서 호출)
  function getEmployeeSubmissionInfo() {
    const currentInfo = printInfo.current;

    if (divRef.current) {
      divRef.current.style.pointerEvents = "none";
    }

    if (backButton) {
      backButton.style.pointerEvents = "none";
    }

    console.log("getEmployeeSubmissionInfo", currentInfo.employeeSubmissionInfo);
    return currentInfo.employeeSubmissionInfo;
  }

  const adminLicenseCheck = (): string => {
    let reslutMsg: string = "";

    if (driverInfo) {
      for (const [index, driver] of driverInfo.entries()) {
        const orderName = index === 0 ? "주운전자" : "부운전자";
        if (driver.licenseSystemError) {
          reslutMsg += `(면허검증 시스템 오류) ${orderName} ${driver.driverName} 면허증 확인 필요`;
        } else {
          let contentText = `(${driver.driverName}) 면허증 `;
          if(driver.isAdminManualCheck) {
            contentText += "확인 완료";
          } else {
            if(driver.driverDirect) {
              contentText += "확인 필요";
            } else {
              if(driver.needCheckCareer.includes(LicenseCheckType.CAREER_RENT) || driver.needCheckCareer.includes(LicenseCheckType.CAREER_INSURANCE)) {
                contentText += "발급일자 확인 필요";
              } else {
                contentText += "스캔 완료";
              }
            }
          }

          reslutMsg += `\n${orderName}${contentText}`;
        }

        // 사전등록이 아니고 면허증 파일이 없을 경우
        if(resInfo?.data.preRegStatus != "Y" && driver.licenseFileList?.length === 0) reslutMsg += ', 면허증 업로드 필요';
      }
    }

    return reslutMsg;
  };

  // 결제 결과 응답 (C# 통신)
  function paySuccess() {
    const approvalResult = (window as any).approvalResult;
    console.log("paySuccess");
    console.log("approvalResult ", approvalResult);
    setConfirmShow(false);
    setConfirmTitle("");
    payProcess(approvalResult);
  }

  function payFail(params: any) {
    setPayCallDisabeld(false);
    console.log("payFail", params);
    const errorMessage = errorMessages[params] || params; // 키값이 없으면 오류 코드 그대로 출력
    setAlertInfoFinal({
      alertShow: true,
      title: "문제 발생",
      content: `${errorMessage}`
    });

    const ApprovalStatus: HTMLInputElement | null = document.getElementById(
      "ApprovalStatus"
    ) as HTMLInputElement | null;

    if (ApprovalStatus?.value) {
      ApprovalStatus.value = "";
    }

    if (divRef.current) {
      divRef.current.style.pointerEvents = "";
    }

    if (backButton) {
      backButton.style.pointerEvents = "";
    }
  }

  const getExportInfo = async () => {
    try{
      await axiosInstance()
        .post(`/kiosk/getExportInfo.do`, {
          companyId: resInfo?.data.companyId,
          reservationId: resInfo?.data.reservationId
        })
        .then((res) => {
          if (res.data) {
            console.log(res.data);
            const parkingLocation = res.data.data.exportLocation || res.data.data.parkingLocationString || "";
            const parkingLocationDetail = res.data.data.exportLocationDetail || res.data.data.parkingLocationDetail || "";

            setParkingStr(parkingLocation);
            setParkingDetail(parkingLocationDetail);

            const carInfoAction = carInfo({
              carNumber: res.data.data.exportCarNum,
              parkingLocationDetail: parkingLocationDetail
            });

            dispatch(carInfoAction);
          }
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 에러",
          content: "에러가 발생했습니다.<br/>다시 시도해주세요.",
          callback: () => history.push("/addEtc")
      });
    }
  }

  // 결제 응답 객체 받고 데이터 처리
  const payProcess = async (approvalResult: ApprovalResult) => {
    try{
      const approvalMemo = `${approvalResult.RS14} (승인번호 : ${approvalResult.RS09})`;
      const requset = {
        kioskUserId: kioskInfo?.data.kioskUserId
          ? kioskInfo?.data.kioskUserId
          : "null",
        // kioskUserId: 'USER_1_2024012400001',
        inoutType: "IN",
        reservationId: resInfo?.data.reservationId,
        approvalValue: totalPrice + (addInsPrice + addProdPrice) || 0,
        approvalMemo: approvalMemo,
        approvalCode: approvalResult.RS09,
        approvalDate: approvalResult.RS07,
        purchaseCorp: approvalResult.RS14,
        approvalResult: JSON.stringify(approvalResult),
        companyId: resInfo?.data.companyId
      };
      console.log(requset);
      setProgressShow(true);
      setPayCallDisabeld(true);
      await axiosInstance()
        .post(`/kiosk/saveApprovalInfo.do`, requset)
        .then(async (res) => {
          if (res.data.status === 200) {
            saveDataProcess();
          }
        })
        .catch((error: AxiosError) => {
          setAlertInfoFinal({
            alertShow: true,
            title: "결제 정보 오류",
            content:
              "결제 정보 저장 중 오류가 발생했습니다.</br>이용에 불편을 드려 죄송합니다."
          });
          setProgressShow(false);
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 오류",
          content: "결제 정보 처리 중 오류가 발생했습니다.</br>이용에 불편을 드려 죄송합니다.<br/>다시 시도해주세요.",
          callback: () => history.push("/addEtc")
      });
    }
  };

  // ERP 내 API 호출, 추후 하나의 통합 API로 만드는 게 좋음
  const saveDataProcess = async () => {
    try{
      /* 키오스크를 통해 자차보험을 가입하고 출고 취소 후, 다시 체크인 하는 경우 보험상품 제거되는 현상 수정 */
      let addInsuranceArr = product?.data?.addInsuranceArr || [];
      if(carIns && carIns[0] && (carIns[0].regType === "KIOSK" || carIns[0].regType === "MOBILE")) {
        addInsuranceArr.push(carIns[0]);
      }

      await axiosInstance()
        .post(`/kiosk/saveAdditionCharge.do`, {
          kioskUserId: kioskInfo?.data.kioskUserId,
          // kioskUserId: 'USER_1_2024012400001',
          companyId: resInfo?.data.companyId,
          reservationId: resInfo?.data.reservationId,
          carInsuranceChargeInfoArray: addInsuranceArr,
          additionRestChargeInfoArray: product?.data?.addProductArr || []
        })
        .then(async (res) => {
          if (
            res.data.status === 200 //&&
            //(resInfo?.data.preRegStatus === "N" ||
            //  (resInfo?.data.preRegStatus === "Y" &&
            //    !resInfo?.data.driver2stName))
            //사전예약해도 내용이 변경될수 있으므로 savedriverinfo는 해야된다.
          ) {
            await axiosInstance()
              .post(`/kiosk/saveDriverInfo.do`, {
                driverList: driverInfo,
                kioskUserId: kioskInfo?.data.kioskUserId
                // kioskUserId: 'USER_1_2024012400001'
              })
              .then(async (res) => {
                driverInfo?.forEach(async (item, idx) => {
                  await axiosInstance().post(`/kiosk/ajaxSaveSignatureImage.do`, {
                    companyId: resInfo?.data.companyId,
                    reservationId: resInfo?.data.reservationId,
                    target:
                      idx === 0
                        ? "SignatureReservation"
                        : "SignatureReservation2",
                    signature: item.singImg
                  });
                });
              })
              .catch((error: AxiosError) => {
                setAlertInfoFinal({
                  alertShow: true,
                  title: "운전자 정보 등록 오류",
                  content:
                    "운전자 정보 저장 중 오류가 발생했습니다.</br>이용에 불편을 드려 죄송합니다."
                });
                setProgressShow(false);
                setPayCallDisabeld(false);
                console.error(error.message);
              });
          }

          ReceiptPrintService.getPrintInfo(resInfo?.data.companyId, resInfo?.data.reservationId).then((res) => {
            const result = res.data.list;
            printInfo.current = convertReceiptListToObject(result);

            const kioskOperation: HTMLInputElement | null = document.getElementById(
              "kioskOperation"
            ) as HTMLInputElement | null;
            if (kioskOperation) {
              // kioskOperation.value =
              //   totalPrice + (addInsPrice + addProdPrice) > 0
              //     ? "printRentInfo"
              //     : "printExchangeTicket";
              kioskOperation.value = "printExchangeTicket";
            }
          });

          await axiosInstance()
            .post("/kiosk/sendSMS.do", {
              companyId: resInfo?.data.companyId,
              reservationId: resInfo?.data.reservationId,
              kioskUserId: kioskInfo?.data.kioskUserId || ""
              // kioskUserId: 'USER_1_2024012400001'
            })
            .catch((error: AxiosError) => {
              // setAlertInfo(
              //   {
              //     alertShow: true,
              //     title: 'SMS 발송 오류',
              //     content: 'SMS 발송 중 에러가 발생했습니다.</br>데스크에 문의 바랍니다.'
              //   }
              // )
              console.error(error.message);
            });

          ReservationService.processOpen(
            resInfo?.data.companyId,
            resInfo?.data.reservationId as string,
            resInfo?.data.processLockVersion
          ).then((res) => {});

          // dispatch({type:'SET_KIOSK'})
        })
        .catch((error: AxiosError) => {
          setAlertInfoFinal({
            alertShow: true,
            title: "추가 상품 등록 오류",
            content:
              "추가 상품 등록 중 오류가 발생했습니다.</br>이용에 불편을 드려 죄송합니다."
          });
          setProgressShow(false);
          setPayCallDisabeld(false);
          console.error(error.message);
          console.error(error);
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 오류",
          content: "운전자 및 상품 정보 처리 중 오류가 발생했습니다.</br>이용에 불편을 드려 죄송합니다.<br/>다시 시도해주세요.",
          callback: () => history.push("/addEtc")
      });
    }
  };

  const getCompanyInfo = async () => {
    try{
      await axiosInstance()
        .get(`/kiosk/admin/companies.do?companyId=${resInfo?.data.companyId}&userId=${kioskInfo?.data.kioskUserId || ""}`)
        // .get(`/kiosk/admin/companies.do?companyId=${resInfo?.data.companyId}&userId=USER_1_2024012400001`)
        .then((res) => {
          console.log("res", res.data);
          setCompanyInfo(res.data.data);
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 오류",
          content: "에러가 발생했습니다.<br/>다시 시도해주세요.",
          callback: () => history.push("/addEtc")
      });
    }
  };

  useEffect(() => {
    getBillInfo();
    getExportInfo();
    getCompanyInfo();

    // 결제 응답을 받기 위해 윈도우 리스너에 등록
    const handleCustomPropertyChange = () => {
      const approvalResult = (window as any).approvalResult;
      // C#에서 해당 이벤트 리스너로 응답을 준다.
      window.addEventListener("approvalResult", approvalResult);
    };

    window.addEventListener("customPropertyChange", handleCustomPropertyChange);

    return () => {
      window.removeEventListener(
        "customPropertyChange",
        handleCustomPropertyChange
      );
    };
  }, []);
  return (
    <>
      <Header></Header>
      <ConfirmModal
        isOpen={confirmShow}
        title={confirmTitle}
        message={confirmMessge}
        onCancel={() => {
          setConfirmShow(false);
          // history.push("/finish");
        }}
        onConfirm={() => {
          if (confirmTitle.includes("결제 영수증 출력 실패")) {
            const kioskOperation: HTMLInputElement | null =
              document.getElementById(
                "kioskOperation"
              ) as HTMLInputElement | null;
            if (kioskOperation) {
              kioskOperation.value = "printRentInfo";
            }
          } else if (confirmTitle.includes("결제 실패")) {
            payCall();
          } else {
            const kioskOperation: HTMLInputElement | null =
              document.getElementById(
                "kioskOperation"
              ) as HTMLInputElement | null;
            if (kioskOperation) {
              kioskOperation.value = "printExchangeTicket";
            }
          }
        }}
      ></ConfirmModal>
      <div className="res-final-wrap" ref={divRef}>
        <div className="res-final-title-wrap">
          <span>예약 최종확인</span>
        </div>

        <div className="res-title-info-wrap">
          <div style={{ height: "80%" }}>
            <div className="info-wrap">
              <span className="title border">렌트카업체</span>
              <span className="content">
                {resInfo?.data?.ownCompanyName || resInfo?.data?.customerName}
              </span>
              <span className="title">총 이용시간</span>
              <span className="content">
                {resInfo?.data?.totalUseHour}시간 {resInfo?.data?.totalUseMinute}
                분
              </span>
            </div>

            <div className="info-wrap">
              <span className="title border">차종</span>
              <span className="content">{resInfo?.data?.modelName}</span>
              <span className="title">차량번호</span>
              <span className="content">{resInfo?.data?.carNumber}</span>
            </div>

            <div className="info-wrap">
              <span className="title border">대여일시</span>
              <span className="content">{resInfo?.data?.takeOverStrDtm}</span>
              <span className="title">반납일시</span>
              <span className="content">{resInfo?.data?.returnStrDtm}</span>
            </div>
            <div className="info-wrap">
              <span className="title border">운전자1</span>
              <span className="content">
                {driverInfo && driverInfo[0].driverName}
              </span>
              <span className="title">운전자2</span>
              <span className="content">
                {" "}
                {driverInfo && driverInfo[1] && driverInfo[1].driverName}
              </span>
            </div>

            <div className="info-wrap">
              <span className="title border">보험명</span>
              <span className="content">
                {(carIns && carIns.length > 0 && carIns[0].insuranceName) ||
                (product?.data &&
                  product?.data.addInsuranceArr &&
                  product?.data.addInsuranceArr.length > 0 &&
                  product?.data.addInsuranceArr[0].carInsuranceInfo.insuranceType !== "4000" &&
                  product?.data.addInsuranceArr[0].carInsuranceInfo.insuranceName) ||
                  "보험 없음"}
              </span>
            </div>

            <div className="info-wrap">
              <span className="title border">특약명</span>
              <span className="content">
                {(product?.data &&
                product?.data.addInsuranceArr &&
                product?.data.addInsuranceArr.length > 0 &&
                product?.data.addInsuranceArr[0].carInsuranceInfo.insuranceType === "4000" &&
                product?.data.addInsuranceArr[0].carInsuranceInfo.insuranceName) || "없음"}
              </span>
            </div>

            <div className="info-wrap">
              <span className="title border">기타상품</span>
              <span className="content">
                {product?.data &&
                product?.data.addProductArr &&
                product?.data.addProductArr.length > 0 ? (
                  product?.data.addProductArr.map((e: any, index: number) => (
                    <span key={index}>
                      {e.restChargeInfo.productName}
                      {index < product?.data.addProductArr.length - 1
                        ? " / "
                        : ""}
                    </span>
                  ))
                ) : (
                  <span>선택 없음</span>
                )}
              </span>
            </div>

            {resInfo?.data && 
              resInfo?.data.feeFieldInput != null &&
              resInfo.data.feeFieldInput > 0 && (
                <div className="info-wrap">
                  <span className="title border">대여료 미납금</span>
                  <span className="content">
                    {formatNumber(resInfo.data.feeFieldInput)}원
                  </span>
                  {/* <span className="content">{formatNumber(resInfo.data.feeFieldInput)}원  {resInfo.data.accountInRequester && resInfo.data.accountInRequester > 0 && <span style={{ color: 'rgb(62, 131, 241)' }}>(입금액 {formatNumber(resInfo.data.accountInRequester)}원)</span>} </span> */}
                </div>
              )}

            {resInfo?.data && 
              resInfo?.data.feeExtendRequester != null &&
              resInfo.data.feeExtendRequester > 0 && (
                <div className="info-wrap">
                  <span className="title border">연장료 미납금</span>
                  <span className="content">
                    {formatNumber(resInfo.data.feeExtendRequester)}원
                  </span>
                  {/* <span className="content">{formatNumber(resInfo.data.feeFieldInput)}원  {resInfo.data.accountInRequester && resInfo.data.accountInRequester > 0 && <span style={{ color: 'rgb(62, 131, 241)' }}>(입금액 {formatNumber(resInfo.data.accountInRequester)}원)</span>} </span> */}
                </div>
              )}
          </div>
          {/* <div style={{ height: "25%" }}></div> */}
          <div>
            <div className="final-price-wrap">
              <div style={{ width: "30%" }}></div>
              <span className="title">현장 결제</span>
              <span
                style={{
                  width: "20%",
                  textAlign: "right",
                  fontWeight: "700",
                  fontSize: "1.2em"
                }}
              >
                {formatNumber(totalPrice || 0)}원
              </span>
            </div>
            <div className="final-price-wrap">
              <div style={{ width: "30%" }}></div>
              <span className="title">추가 금액</span>
              <span
                style={{
                  width: "20%",
                  textAlign: "right",
                  fontWeight: "700",
                  fontSize: "1.2em"
                }}
              >
                {formatNumber(addInsPrice + addProdPrice || 0)}원
              </span>
            </div>
            <div
              className="final-price-wrap"
              style={{
                borderBottomLeftRadius: "0.7em",
                borderBottomRightRadius: "0.7em"
              }}
            >
              <div style={{ width: "30%" }}></div>
              <span className="title">총 결제 금액</span>
              <span
                style={{
                  width: "20%",
                  textAlign: "right",
                  fontWeight: "700",
                  fontSize: "1.4em",
                  color: "#3E83F1"
                }}
              >
                {formatNumber(totalPrice + (addInsPrice || 0) + addProdPrice)}원
              </span>
            </div>
          </div>

          <div className="total-pay-wrap">
            <div style={{ width: "50%", marginRight: "40px" }}>
              <div className="pay-info-wrap">
                <span className="install">할부 개월</span>
                <div className="install-select">
                  <span
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                    onClick={() => setInstallShow(!installShow)}
                  >
                    {installText}
                    <SvgIcon
                      component={ArrowDropDownOutlinedIcon}
                      style={{
                        fontSize: "1.8em",
                        color: "#e4e7ec"
                      }}
                    ></SvgIcon>
                  </span>
                  {installShow && (
                    <div className="select-item">
                      <span
                        onClick={() => {
                          installClick(0);
                        }}
                      >
                        일시불
                      </span>

                      {months.map((e) => (
                        <span
                          key={e}
                          onClick={() => {
                            installClick(e);
                          }}
                          className={installIdx === e ? "active" : ""}
                        >
                          {e}개월
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="pay-info-wrap">
                <span className="install">추가 금액 </span>
                <span className="total-pay-count">
                  {" "}
                  {formatNumber(totalPrice + (addInsPrice + addProdPrice || 0))}
                  원
                </span>
              </div>
            </div>
            <div className="btn-wrap" style={{ width: "50%" }}>
              <button
                onClick={() => {
                  const ApprovalStatus: HTMLInputElement | null =
                    document.getElementById(
                      "ApprovalStatus"
                    ) as HTMLInputElement | null;

                  if (ApprovalStatus) {
                    if (ApprovalStatus.value === "") {
                      payCall();
                    }
                  }
                }}
                className={payCallDisabled ? "disabled" : ""}
              >
                {totalPrice || 0 + (addInsPrice + addProdPrice) > 0
                  ? "결제하기"
                  : "완료"}
              </button>
            </div>
          </div>
        </div>
        {/* {payModalShow && (
          <PayModal onClick={() => {}} onClose={() => {}}></PayModal>
        )} */}
        {progressShow && <ProgressBar width={0}></ProgressBar>}
      </div>

      {alertInfoFinal.alertShow && (
        <AlertModal
          onClose={() => {
            setAlertInfoFinal((prev) => ({
              ...prev,
              alertShow: false
            }));
          }}
          title={alertInfoFinal.title}
          content={alertInfoFinal.content}
        ></AlertModal>
      )}
      {alertInfo.show && (
        <AlertModal
          onClose={() => {
            if (alertInfo.callback) {
              alertInfo.callback(); // 콜백 함수 호출
            } else setAlertInfo((prev) => ({ ...prev, show: false }));
          }}
          title={alertInfo.title}
          content={alertInfo.content}
        ></AlertModal>
      )}
      <input type="hidden" name="kioskOperation" id="kioskOperation" value="" />
      <input type="hidden" name="ApprovalStatus" id="ApprovalStatus" value="" />
      <input type="hidden" name="transactionNum" id="transactionNum" value="" />
      <input type="hidden" name="approvalCharge" id="approvalCharge" value="" />
      <input type="hidden" name="approvalInstallMonth" id="approvalInstallMonth" value=""></input>
      <input type="hidden" name="ApprovalAccountId" id="ApprovalAccountId" value=""></input>
      <input type="hidden" name="ApprovalCompanyName" id="ApprovalCompanyName" value={companyInfo.receiptCompanyName}></input>
      <input type="hidden" name="ApprovalCompanyCEO" id="ApprovalCompanyCEO" value={companyInfo.ceoName}></input>
      <input type="hidden" name="ApprovalCompanyTel" id="ApprovalCompanyTel" value={companyCallInfo}></input>
      <input type="hidden" name="ApprovalCompanyRegNum" id="ApprovalCompanyRegNum" value={companyInfo.receiptBusinessNum}></input>
      <input type="hidden" name="ApprovalCompanyAddr" id="ApprovalCompanyAddr" value={customerAdress}></input>
      <input type="hidden" name="receiptPrintStatus" id="receiptPrintStatus" value=""></input>
      
      <input type="hidden" name="COMPANY_CALL_INFO" id="COMPANY_CALL_INFO" value={companyCallInfo}></input>
      <input type="hidden" name="CUSTOMER_CAUTION" id="CUSTOMER_CAUTION" value={customerCaution}></input>
      <input type="hidden" name="RETURN_ADDR_INFO" id="RETURN_ADDR_INFO" value={returnAddrInfo}></input>
      
      <input type="hidden" name="employeeContentUse" id="employeeContentUse" value={resInfo?.data?.employeeContentUse}></input>
      <input type="hidden" name="customerParkingLocationUse" id="customerParkingLocationUse" value={resInfo?.data?.customerParkingLocationUse}></input>
      <input type="hidden" name="limitPriceUse" id="limitPriceUse" value={resInfo?.data?.limitPriceUse}></input>
      <input type="hidden" name="parkingDetail" id="parkingDetail" value={parkingDetail}></input>
      <input type="hidden" name="parkingStr" id="parkingStr" value={parkingStr}></input>
      <input type="hidden" name="modelName" id="modelName" value={resInfo?.data?.modelName}></input>
      <input type="hidden" name="carNumber" id="carNumber" value={resInfo?.data?.carNumber}></input>
      <input type="hidden" name="returnDtm" id="returnDtm" value={resInfo?.data?.returnStrDtm}></input>
      <input type="hidden" name="driver01Name" id="driver01Name" value={(driverInfo && driverInfo[0].driverName) || ""}></input>
      <input type="hidden" name="driver01Tel" id="driver01Tel" value={(driverInfo && driverInfo[0].tel) || ""}></input>
      <input type="hidden" name="driver02Tel" id="driver02Tel" value={(driverInfo && driverInfo[1] && driverInfo[1].tel) || ""}></input>
      <input type="hidden" name="driver02Name" id="driver02Name" value={(driverInfo && driverInfo[1] && driverInfo[1].driverName) || ""}></input>
      
      <input type="hidden" name="insuranceName" id="insuranceName"
        value={
          (carIns && carIns.length > 0 && carIns[0].insuranceName) ||
          (addedInsurance && addedInsurance.length > 0 && addedInsurance[0].insuranceName) ||
          "보험 없음"
        }
      ></input>
      <input type="hidden" name="limitPrice" id="limitPrice"
        value={
          (carIns &&
            carIns.length > 0 &&
            carIns[0].carInsuranceInfo &&
            carIns[0].carInsuranceInfo.limitPrice) ||
          ""
        }
      ></input>
      <input type="hidden" name="customerName" id="customerName" value={resInfo?.data?.customerName}></input>
      <input type="hidden" name="ownerCompanyName" id="ownerCompanyName" value={resInfo?.data?.ownCompanyName || resInfo?.data?.customerName}></input>

      <textarea
        // type="text"
        name="adminLicenseCheck"
        id="adminLicenseCheck"
        defaultValue={adminLicenseCheck()}
        value={adminLicenseCheck()}
        readOnly
        // style={{
        //   width: "300px",
        //   height: "300px",
        //   position: "absolute",
        //   top: "10px",
        // }}
      ></textarea>
    </>
  );
};

export default ResFinal;
